import {RateAggregate, RateAggregatePolicy} from 'Quoting/models/DTOs/RatePremium';
import {QuoteStatus} from 'Quoting/models/enum';
import {formatPremium, isDefined} from 'Quoting/utils/utilities';
import {DateTime} from 'luxon';

export const getRateAggregatePolicy = (rateAggregates: RateAggregate[] | undefined) => {
  const latestRateAggregate = getLatestRateAggregate(rateAggregates);
  return latestRateAggregate?.ratePremiumEntry ? latestRateAggregate?.ratePremiumEntry?.policy : undefined;
};

export const hasRateAggregateCalculated = (
  rageAggregatePolicy: RateAggregatePolicy | undefined,
  quoteStatus: string | undefined
) => isDefined(rageAggregatePolicy) && rageAggregatePolicy?.rateCardPremium && quoteStatus !== QuoteStatus.DataGather;

const getLatestRateAggregate = (rateAggregates: RateAggregate[] | undefined) => {
  if (Array.isArray(rateAggregates) && rateAggregates.length > 0) {
    return rateAggregates.length <= 1 ? rateAggregates[0] : sortRateAggretagesByCreatedOnDate(rateAggregates)?.[0];
  }
};

const sortRateAggretagesByCreatedOnDate = (rateAggregates: RateAggregate[]) => {
  return [...rateAggregates].sort(({accessTrackInfo: accessTrackInfoA}, {accessTrackInfo: accessTrackInfoB}) => {
    if (!accessTrackInfoA?.createdOn) {
      return -1;
    }
    if (!accessTrackInfoB?.createdOn) {
      return 1;
    }
    const createdOnDateA = DateTime.fromISO(accessTrackInfoA.createdOn);
    const createdOnDateB = DateTime.fromISO(accessTrackInfoB.createdOn);
    return createdOnDateB.diff(createdOnDateA).milliseconds;
  });
};

export const getRateAggregatePolicyPremium = (rateAggregates: RateAggregate[] | undefined) => {
  const rateAggregatePolicy = getRateAggregatePolicy(rateAggregates);
  return isDefined(rateAggregatePolicy)
    ? formatPremium(rateAggregatePolicy?.rateCardPremium?.annualPremium?.amount, undefined, 'N/A')
    : 'N/A';
};
